import DatasetIvy from "../../features/dataset/components/table/DatasetsTables/DatasetIvy";
import DatasetWorksheet from "../../features/dataset/components/table/DatasetsTables/DatasetWorksheet";
import SliderTab from "/src/components/slider/sliderTab";
import { PageTable, Header } from "/src/layouts/page";
function DatasetList() {
    //
    const items = [
        { name: "Worksheet", component: <DatasetWorksheet /> },
        { name: "QnA", component: <DatasetIvy /> },
    ];

    return (
        <PageTable>
            <Header title="List of Datasets" />
            <SliderTab items={items} name="datasets"></SliderTab>
        </PageTable>
    );
}

export default DatasetList;
